import { InvoiceDTO } from '../services/apiClient';
import { InvoiceTypeConstants } from '../constants/InvoiceTypeConstants';
import { InvoiceStatusConstants } from '../constants/InvoiceStatusConstants';

const SALES_ORDER_TYPE_IDS: string[] = [InvoiceTypeConstants.SALES_ORDER_RENEWAL, InvoiceTypeConstants.SALES_ORDER_ONCE_OFF];
const UNPAID_STATUS_IDS: string[] = [InvoiceStatusConstants.CREATED, InvoiceStatusConstants.SENT];

// Only unpaid sales orders (not yet invoiced/finalized) can be selected for a Netcash push.
export const isInvoiceSelectableForNetcash = (row: InvoiceDTO): boolean =>
  !!row.invoiceTypeId && SALES_ORDER_TYPE_IDS.includes(row.invoiceTypeId.toLowerCase())
  && !!row.invoiceStatusId && UNPAID_STATUS_IDS.includes(row.invoiceStatusId.toLowerCase());
